import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {EditableItemField} from '../../interfaces/EditableItemField';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ComplimentService} from '../../../form-renderer/services/feedback/compliment.service';
import {ComplaintService} from '../../../form-renderer/services/feedback/complaint.service';
import {ExceptionPhotosComponent} from '../exception-photos/exception-photos.component';
import {FormUtilities} from '../../FormUtilities';


@Component({
  selector: 'app-add-item-modal',
  templateUrl: './add-item-dialog.component.html',
  styleUrls: ['./add-item-dialog.component.scss']
})
/**
 * Dialog form used to add a new item to a collection of data
 */
export class AddItemDialogComponent implements OnInit {

  @ViewChild(ExceptionPhotosComponent)
  private exceptionPhotosComponent: ExceptionPhotosComponent;

  buttonText = 'Create';
  uploadFileName: string;
  addItemForm: FormGroup;
  fileUploads: {[key: string]: File}= {};

  constructor(public dialogRef: MdDialogRef<AddItemDialogComponent>,
              @Inject(MD_DIALOG_DATA) public data: DialogData,
              private complimentService: ComplimentService,
              private complaintService: ComplaintService,
              private formBuilder: FormBuilder,
              private formUtils: FormUtilities) {
    this.createForm();
  }

  public getFieldPlaceholder(field: EditableItemField) {
    return field.label ? field.label : field.name;
  }


  ngOnInit() {
    if (this.data.submitText)
      this.buttonText = this.data.submitText;
    else if (this.data.item)
      this.buttonText = 'Update';
  }
  /**
   * Scaffold out the fieldForm
   */
  createForm() {
    // object we will use to create the form group

    const group: any = {};
    this.data.fields.map(field => {
      // create a new form control for each field passed in
      const name = this.formatFieldName(field.name);
      if (this.data.item) {
        group[name] = new FormControl(this.data.item[name], field.required === false ? [] : Validators.required);

        if (field.type === 'upload')
          group[name] = new FormControl(this.data.item[name]);
      } else {
        if (field.type === 'datepicker') {
          group[name] = new FormControl(new Date(), field.required === false ? [] : Validators.required);
        } else {
            group[name] = field.type === 'checkbox' ?
                new FormControl(false, field.required === false ? [] : Validators.required) :
                new FormControl('', field.required === false ? [] : Validators.required);
        }

        if (field.type === 'upload')
          group[name] = field.required === true ? new FormControl('', Validators.required) : new FormControl('');
    }});
    this.addItemForm = this.formBuilder.group(group);
  }
  /**
   * Closes the dialog and returns the form value
   */
  onSubmit() {
    if (this.exceptionPhotosComponent)
      this.exceptionPhotosComponent.saveChanges();
    if (this.data.item) {
      this.dialogRef.close({
        ...this.data.item,
        ...this.addItemForm.value,
        ...this.fileUploads
      });
    } else {
      const formValue = this.addItemForm.value;
      for ( const key in this.fileUploads) {
        if (this.fileUploads.hasOwnProperty(key))
          formValue[key] = this.fileUploads[key];
      }
      this.dialogRef.close(formValue);
    }
  }


  fileRemoved(id: number, component: string) {
    if (component === 'compliment') {
      this.complimentService.fileDelete(id).then(() => {
        this.dialogRef.close({
          ...this.data.item,
          ...this.addItemForm.value,
          ...this.fileUploads
        });
      })
    } else {
      this.complaintService.fileDelete(id).then(() => {
        this.dialogRef.close({
          ...this.data.item,
          ...this.addItemForm.value,
          ...this.fileUploads
        });
      })
    }
  }

  formatFieldName(str) {
    return str
      .replace(/\s/g, '')
      .toLowerCase();
  }


  fileChange(name) {
    const buttonText = document.getElementById('upload');
    this.formUtils.chooseFile(['.pdf', '.doc', '.docx'])
      .then((fileToUpload) => {
        this.fileUploads[name] = fileToUpload;
        if (this.fileUploads[name].name) {
          buttonText.innerText = 'Change File';
        }
        this.uploadFileName = this.fileUploads[name].name;
    });
  }
}

interface DialogData {
  name: string;
  fields?: EditableItemField[];
  item: any;
  submitText: string;
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/add-item-dialog/add-item-dialog.component.ts